import FlashContext from "components/FlashMessages/FlashContext";
import useTypedContext from "hooks/useTypedContext";
import { Module } from "types/generated";
import useDisableModule from "shared/Module/useDisableModule";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import { AccessResult } from "utils/access";

type DisableButtonProps = {
  moduleId: Module["id"];
  refetchQueries?: string[];
  callback?: () => void;
  canDisable: AccessResult;
};

const DisableButton = ({ moduleId, callback, refetchQueries, canDisable }: DisableButtonProps) => {
  const { reportSuccess } = useTypedContext(FlashContext);

  const [disableModule, { loading }] = useDisableModule({
    refetchQueries,
  });

  const handleClick = () => {
    disableModule({ id: moduleId }, (data) => {
      if (data?.moduleDisable) {
        reportSuccess({ message: "Module successfully disabled" });
        callback?.();
      }
    });
  };

  if (!canDisable.result && !canDisable.message) {
    return null;
  }

  return (
    <DropdownMenuItem
      onAction={handleClick}
      loading={loading}
      isDisabled={loading || !canDisable.result}
      tooltip={canDisable.message}
      tooltipWidthMode="maxWidthSm"
    >
      Disable
    </DropdownMenuItem>
  );
};

export default DisableButton;
